// extracted by mini-css-extract-plugin
export default {"customOption":"CustomOption_customOption__PSTUl","label":"CustomOption_label__K-IKR","description":"CustomOption_description__qsYcU","row":"CustomOption_row__+uott"};